import { useState, useEffect, useRef } from 'react';

// Auth & JWT
import { isUserLoggedIn } from "@core/auth/utils";

// Redux & Action
import { useDispatch, useSelector } from 'react-redux';
import { setHomeMenuType } from "@core/redux/actions/home/index";
import { setDataPosition } from "@core/redux/actions/app/scrollPosition";
import { loadGameList } from "@core/redux/actions/game/index";

// Component
import MenuList from "./../../../component/MenuList";
import MenuListBar from "./../../../component/MenuListBar";
import MenuHomeContent from "./MenuContent/Home";
import MenuGameContent from "./MenuContent/Game";
import MenuOtherContent from "./MenuContent/Other";

// Style & CSS
import "assets/css/Animation.css";

export default function Content({ dataSetting, isLargeScreen }) {
    const dataCampList = useSelector(state => state.reduxCamp.result);
    const dataMenu = useSelector(state => state.reduxHome.menu);
    const dispatch = useDispatch();
    const [menuDataList, setMenuDataList] = useState(null);
    const scrollRef = useRef();
    const itemsGameList = useSelector(state => state.reduxGame.itemsGameList);
    const [campSlot, setCampSlot] = useState([]);
    const [campCasino, setCampCasino] = useState([]);
    const [campSport, setCampSport] = useState([]);
    const [campLottery, setCampLottery] = useState([]);
    const [gameLoadStatus, setGameLoadStatus] = useState(false);
    const selectCampData = useSelector(state => state.reduxCamp.selectCamp);

    const renderPageTabs = () => {
        if (dataMenu.gameCampType === 99) {
            return <MenuHomeContent campSlot={campSlot} campCasino={campCasino} campSport={campSport}></MenuHomeContent>;
        }
        else if (dataMenu.gameCampType === 0) {
            return <MenuGameContent campSlot={campSlot} selectCampData={selectCampData} dataMenu={dataMenu} gotoScroll={gotoScroll} loadGameData={loadGameData} isLargeScreen={isLargeScreen}></MenuGameContent>;
        }
        else {
            return <MenuOtherContent itemsGameList={itemsGameList} dataMenu={dataMenu}></MenuOtherContent>;
        }
    };

    const selectPageHome = (item) => {
        let gameCampType = item.game_camp_type;
            dispatch(setHomeMenuType({
                id: item.id,
                renderPage: item.code,
                pageTitle: item.title,
                gameCampType: gameCampType,
                gameCampImage: item.game_camp_image,
                column: {
                    desktop: item.column_desktop,
                    mobile: item.column_mobile
                },
                typeGame: gameCampType
            }));
    
            reloadGameAll(gameCampType);
    };

    const reloadGameAll = (gameCampType) => {
        if (gameCampType !== 99 && gameCampType !== 0) {
            if (itemsGameList[gameCampType] === undefined) {
                setGameLoadStatus(false);
                if (gameCampType === 6 || gameCampType === 11 || gameCampType === 13) {
                    let gameCampList = [];
                    let gameCampAll = {
                        data: [],
                        count: 0
                    };

                    if (gameCampType === 6) {
                        campCasino.forEach((item, index) => {
                            let setObj = {};
                            setObj["id"] = index;
                            setObj["at"] = index;
                            setObj["bet"] = item.bet;
                            setObj["camp"] = item.camp;
                            setObj["cashback"] = 0;
                            setObj["code"] = item.code;
                            setObj["commission"] = 0;
                            setObj["customer"] = item.customer;
                            setObj["game_code"] = item.game_code;
                            setObj["image"] = item.image;
                            setObj["name"] = item.camp;
                            setObj["open"] = item.open;
                            setObj["status"] = item.status;
                            setObj["jackpot"] = item.jackpot;
                            setObj["specials"] = item.specials;
                            setObj["win"] = item.win;
                            setObj["win_rate"] = item.win_rate;

                            gameCampList = [...gameCampList, setObj];
                        });

                        gameCampAll.count = campCasino.length;
                        gameCampAll.data = gameCampList;
                    }
                    else if (gameCampType === 13) {
                        campLottery.forEach((item, index) => {
                            let setObj = {};
                            setObj["id"] = index;
                            setObj["at"] = index;
                            setObj["bet"] = item.bet;
                            setObj["camp"] = item.camp;
                            setObj["cashback"] = 0;
                            setObj["code"] = item.code;
                            setObj["commission"] = 0;
                            setObj["customer"] = item.customer;
                            setObj["game_code"] = item.game_code;
                            setObj["image"] = item.image;
                            setObj["name"] = item.camp;
                            setObj["open"] = item.open;
                            setObj["status"] = item.status;
                            setObj["jackpot"] = item.jackpot;
                            setObj["specials"] = item.specials;
                            setObj["win"] = item.win;
                            setObj["win_rate"] = item.win_rate;

                            gameCampList = [...gameCampList, setObj];
                        });

                        gameCampAll.count = campLottery.length;
                        gameCampAll.data = gameCampList;
                    }
                    else {
                        campSport.forEach((item, index) => {
                            let setObj = {};
                            setObj["id"] = index;
                            setObj["at"] = index;
                            setObj["bet"] = item.bet;
                            setObj["camp"] = item.camp;
                            setObj["cashback"] = 0;
                            setObj["code"] = item.code;
                            setObj["commission"] = 0;
                            setObj["customer"] = item.customer;
                            setObj["game_code"] = item.game_code;
                            setObj["image"] = item.image;
                            setObj["name"] = item.camp;
                            setObj["open"] = item.open;
                            setObj["status"] = item.status;
                            setObj["jackpot"] = item.jackpot;
                            setObj["specials"] = item.specials;
                            setObj["win"] = item.win;
                            setObj["win_rate"] = item.win_rate;

                            gameCampList = [...gameCampList, setObj];
                        });

                        gameCampAll.count = campSport.length;
                        gameCampAll.data = gameCampList;
                    }

                    loadGameData("", gameCampType, "", -1, 0, false, false, gameCampAll);
                }
                else {
                    loadGameData("", gameCampType, "", 15, 0, false, true, null);
                }
            }
            else {
                setGameLoadStatus(true);
            }
        }
        else {
            setGameLoadStatus(true);
            gotoScroll();
        }
    };

    const loadGameData = (camp, type, filter, limit, offset, statusUseScroll = false, reqStatus, dataGamelist = []) => { // โหลดข้อมูลเกม
        dispatch(loadGameList({ camp, type, filter, limit, offset, statusUseScroll }, itemsGameList, reqStatus, dataGamelist, setGameLoadStatus));
    };

    const gotoScroll = () => {
        setTimeout(() => {
            let offsetTopData = scrollRef?.current?.offsetTop;
            let positionTop = (offsetTopData === undefined ? 0 : offsetTopData) - 80;
            let scrollPosition = document.body.getBoundingClientRect().top;
            dispatch(setDataPosition(positionTop));

            if (scrollPosition < positionTop) {
                window.scrollTo({
                    top: positionTop,
                    left: 0,
                    behavior: "smooth"
                });
            }
        }, 100)
    };

    useEffect(() => {
        if (dataSetting.menu_camp !== null) {
            let menuArr = dataSetting.menu_camp;
            if (menuArr.length > 0) {
                if (dataMenu === null) {
                    let item = menuArr[0];

                    dispatch(setHomeMenuType({
                        id: item.id,
                        renderPage: item.code,
                        pageTitle: item.title,
                        gameCampType: item.game_camp_type,
                        gameCampImage: item.game_camp_image,
                        column: {
                            desktop: item.column_desktop,
                            mobile: item.column_mobile
                        },
                        typeGame: item.game_camp_type
                    }));
                }
            }

            setMenuDataList(menuArr);
        }
    }, [dataSetting.menu_camp]);

    useEffect(() => {
        if (dataCampList !== null) {
            let dataCampSlot = [];
            let dataCampCasino = [];
            let dataCampSport = [];
            let dataCampLottery = [];

            dataCampList.forEach(item => {
                if (item.category === 0) {
                    dataCampSlot = [...dataCampSlot, item];
                }
                else if (item.category === 1) {
                    dataCampCasino = [...dataCampCasino, item];
                }
                else if (item.category === 3 || item.category === 4) {
                    dataCampSport = [...dataCampSport, item];
                }
                else if (item.category === 6) {
                    dataCampLottery = [...dataCampLottery, item];
                }
            });

            setCampSlot(dataCampSlot);
            setCampCasino(dataCampCasino);
            setCampSport(dataCampSport);
            setCampLottery(dataCampLottery);
        }
    }, [dataCampList]);

    useEffect(() => {
        if (dataMenu !== null) {
            if (dataMenu.gameCampType === 99) {
                setGameLoadStatus(true);
            }
            else {
                setGameLoadStatus(true);
                // if (dataMenu.typeGame === 0) {
                //     setGameLoadStatus(true);
                // }
                // else {
                //     // reloadGameAll(dataMenu.gameCampType);
                // }

                if (gameLoadStatus) {
                    gotoScroll();
                }
            }
        }
    }, [dataMenu, gameLoadStatus]);

    // useEffectOnce(() => {
    //     if (selectCampData !== null && selectCampData !== undefined) {
    //         loadGameData(selectCampData, dataMenu.gameCampType, "", 12, 0, false, true, null);
    //     }
    // }, [selectCampData]);

    return (
        <>
            {
                isUserLoggedIn() && (
                    <div className="menuListBarTop">
                        <MenuListBar isLargeScreen={isLargeScreen} menu_second={dataSetting?.menu_second}></MenuListBar>
                    </div>
                )
            }

            {
                menuDataList !== null && (
                    <div className="contentMediumMarginTop" ref={scrollRef}>
                        <MenuList dataList={menuDataList} selectPageHome={selectPageHome} isLargeScreen={isLargeScreen}></MenuList>
                    </div>
                )
            }

            <div className="componentMarginTop">
                <div className="componetHeight">
                    {
                        dataMenu !== null && (
                            gameLoadStatus && (
                                renderPageTabs()
                            )
                        )
                    }
                </div>
            </div>
        </>
    );
}